import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import React, { useCallback, useMemo } from 'react'

interface LocationContainer {
  id: string
  services?: string[] | null
}

interface MoveContainerPinsCardProps {
  containers: LocationContainer[]
  checked: boolean
  onChange: (checked: boolean) => void
}

const pluralize = (count: number, noun: string) => `${count} ${noun}${count === 1 ? '' : 's'}`

const MoveContainerPinsCard = ({ containers, checked, onChange }: MoveContainerPinsCardProps) => {
  const handleChange = useCallback((_event: React.ChangeEvent<HTMLInputElement>, isChecked: boolean) => onChange(isChecked), [onChange])

  const serviceCount = useMemo(() => new Set(containers.flatMap(container => container.services || [])).size, [containers])

  const summary =
    serviceCount > 0
      ? `${pluralize(containers.length, 'container')} across ${pluralize(serviceCount, 'service')} will update when you save`
      : `${pluralize(containers.length, 'container')} will update when you save`

  return (
    <Box>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleChange} />}
        label={<Typography variant="h6">Update container location</Typography>}
        sx={{ ml: 0 }}
      />
      {checked && (
        <Alert severity="info" sx={{ mt: 0.5 }}>
          <Typography variant="body1">{summary}</Typography>
        </Alert>
      )}
    </Box>
  )
}

export default MoveContainerPinsCard
